import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import colors from '@app/constants/colors';
import ErrorMessage from './ErrorMessage';

const CheckBox = ({
  labelId,
  input,
  required,
  meta: {
    touched,
    error,
  },
}) => {
  const isError = touched && error;

  return (
    <div>
      <CheckBoxInnerContainer className="container" isError={isError}>
        <input type="checkbox" {...input} />
        <CheckMark isChecked={!!input.value} isError={isError} />
        <FormattedMessage id={labelId} />
        &nbsp;
        { !!required && '*'}
      </CheckBoxInnerContainer>
      {
        isError && <ErrorMessage error={error} />
      }
    </div>
  );
};

CheckBox.propTypes = {
  /* eslint-disable-next-line */
  input: PropTypes.object.isRequired, //data that passed by Field component itself
  required: PropTypes.bool,
  labelId: PropTypes.string.isRequired, // label id from translations
  meta: PropTypes.shape({ // data that passed by Field component itself
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([ // error passed to <Field> as validate prop
      PropTypes.string,
      PropTypes.array,
    ]),
  }),
};

CheckBox.defaultProps = {
  required: false,
  meta: {},
};

export default CheckBox;

const CheckBoxInnerContainer = styled.label`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin: 10px 0;
  color: ${({ isError }) => (isError ? colors.APPLE_BLOSSOM : 'white')};

  & input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
`;

const CheckMark = styled.span`
  width: 35px;
  height: 35px;
  border-radius: 10px;
  border: 1px solid;
  border-color: ${({ isError }) => (isError ? colors.APPLE_BLOSSOM : 'white')};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  
  &:after {
    content: url('/images/checkMark.svg');
    display: ${({ isChecked }) => (isChecked ? 'block' : 'none')};
    width: 22px;
  }
  
  &:focus {
    border-width: 2px;
  }
`;
